import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Stagger, StaggerItem } from "@/components/motion";
import SectionHeader from "@/components/SectionHeader";
import { INDUSTRIES } from "@/data/site";

export default function IndustriesGrid({ showHeader = true }) {
  return (
    <section className="dq-container py-20 lg:py-28" data-testid="industries-section" id="industries">
      {showHeader && (
        <div className="mb-14 flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHeader
            eyebrow="Industries we serve"
            title="Deep expertise across"
            highlight="every industry"
            subtitle="From clinics to restaurants to real estate — we know what makes your customers choose you."
          />
          <Link to="/industries" data-testid="industries-view-all" className="btn-secondary shrink-0">
            Explore industries <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      )}

      <Stagger className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" stagger={0.05}>
        {INDUSTRIES.map((ind) => (
          <StaggerItem key={ind.title}>
            <div className="group flex items-center gap-4 rounded-2xl border border-dq-line bg-white p-5 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-dq-orange/30"
              data-testid={`industry-card-${ind.title.toLowerCase().replace(/\s/g, "-")}`}>
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-dq-bg text-dq-orange transition-colors duration-300 group-hover:bg-dq-orange group-hover:text-white">
                <ind.icon className="h-5 w-5" />
              </span>
              <span className="font-display text-sm font-bold text-dq-ink">{ind.title}</span>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
